import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '@com-delta-idp/mnx-oauth';
import {
  CommonConstants,
  EndpointKeys,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  CustomError,
  handleError,
  HttpRequestMethods,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FutureActivityRequest,
  FutureActivityResponse
} from '../../models/api/future-activities.interfaces';
import {
  COMMON_HEADER_KEY,
  commonHeaderInfo
} from '../../models/overview.constants';

@Injectable({
  providedIn: 'root'
})
export class FutureActivityService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private session: SessionService
  ) {}

  getFutureActivities = (
    payload: FutureActivityRequest,
    trackerApi: boolean
  ): Observable<FutureActivityResponse | undefined> => {
    const request: FutureActivityRequest = payload;
    commonHeaderInfo['X-Delta-DLCOM_Loyalty_App_Test'] = COMMON_HEADER_KEY;
    commonHeaderInfo['Authorization'] = this.session.token.access_token;

    const endpointKey = trackerApi
      ? EndpointKeys['SKYMILES_API_FUTURE_ACTIVITIES_MULTI_REGION']
      : EndpointKeys['SKYMILES_API_FUTURE_ACTIVITIES'];

    return new ApiBuilder<
      FutureActivityRequest,
      FutureActivityResponse | CustomError
    >(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(endpointKey)
      .method(HttpRequestMethods['POST'])
      .payload(request)
      .httpHeaders(commonHeaderInfo)
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .withCredentials(true)
      .create()
      .pipe(
        map((response: FutureActivityResponse | CustomError) => {
          return this.existCustomError(response, endpointKey);
        })
      );
  };

  existCustomError(
    response: FutureActivityResponse | CustomError,
    endpointKey: string
  ): FutureActivityResponse {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        endpointKey
      );
      throw throwError(response);
    }
    return response;
  }
}
